 <template>
  <div>    
    <p class="title-user-scr">Datos de la propiedad</p>  
    <v-row>   
      <v-col cols="4">
        <v-text-field 
          dense 
          :disabled="modeEdit"           
          v-model="manzana"          
          label="Manzana*"></v-text-field>
      </v-col>  
      <v-col cols="4">
        <v-text-field 
          dense 
          :disabled="modeEdit"          
          v-model="lotenum"          
          label="Lote*"></v-text-field>
      </v-col> 
      <v-col cols="4">
        <v-text-field dense :rules="rules.lonsm" v-model="street" label="Calle"></v-text-field>
      </v-col> 
      <v-col cols="4">
      <v-autocomplete
            dense
            item-text="title"            
            return-object     
            v-model="legalStatus"         
            :items="statusPredio"
            filled
            label="Status Predio"
          >
        </v-autocomplete>  
      </v-col>
    </v-row>
    
    <p class="title-user-scr">Datos del propietario titular</p>  
    <v-row>
      <v-file-input
        v-if="!isAdmin"
        ref="uploadImage"
        @change="selectFile"
        accept="image/*"
        label="Seleccionar una foto"
      ></v-file-input>
      
      <v-col cols="12">
        <v-text-field dense :rules="rules.name" v-model="username" label="Nombre completo"></v-text-field>
      </v-col>
      
      <v-col cols="6">
        <v-text-field
          dense
          :rules="rules.mobileReq"
          v-model="mobilePhone"
          placeholder="999-999-9999"
          name="celular"
          label="Celular*"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field dense :rules="rules.email" v-model="email" label="Correo electrónico*"></v-text-field>
      </v-col>      
    </v-row>
    
    <v-row>     
      <v-col cols="4">
        <v-switch
          v-model="hasWhats"
          label="Incluido en WhatsApp"
          hide-details
          inset
        ></v-switch>
      </v-col>
      <v-col cols="4">       
        <v-autocomplete
            dense
            item-text="title"            
            return-object
            v-model="statusDebt"
            :items="statusSocio"
            filled
            label="Status"
          >
        </v-autocomplete>  
      </v-col>
      <v-col cols="4">
        <v-text-field dense :rules="rules.lonsm" v-model="placeOfResidence" label="Lugar residencia"></v-text-field>
      </v-col>    
    </v-row>

    <p class="title-user-scr">Acceso App</p>  
    <v-col cols="12">
      <v-text-field :disabled="modeEdit" dense v-model="usernameLogin" label="Usuario*"></v-text-field>
    </v-col>
    <v-row>
      <v-col md="6">
        <v-text-field
          dense
          :rules="modeEdit && !password.length ? [] : [rules.required, rules.min]"
          :type="show1 ? 'text' : 'password'"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          v-model="password"
          label="Contraseña"
          @click:append="show1 = !show1"
        ></v-text-field>
      </v-col>
      <v-col md="6">
        <v-text-field
          dense
          :rules="modeEdit && !password.length ? [] : [rules.required, rules.min]"
          :type="show2 ? 'text' : 'password'"
          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          v-model="confirmPassword"
          label="Confirmar contraseña"
          @click:append="show2 = !show2"
        ></v-text-field>
      </v-col>
    </v-row>

    <p class="title-user-scr">Datos contacto secundario</p>  
    <v-row>   
      <v-col cols="12">
        <v-text-field dense :rules="rules.lonmd" v-model="contactName" label="Nombre completo"></v-text-field>
      </v-col>      
      <v-col cols="6">
        <v-text-field
          dense        
          :rules="rules.mobile" 
          v-model="contactMobile"
          placeholder="999-999-9999"
          name="celular"
          label="Celular"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field dense :rules="rules.emailContact" v-model="contactEmail" label="Correo electrónico"></v-text-field>
      </v-col>    
    </v-row>  

    <div v-if="isAdmin">
      <p class="title-user-scr">Control de accesos TAGS</p>  
      <v-row>      
        <v-col cols="4">
          <v-text-field dense :rules="rules.onlyNumbers" maxlength="30" v-model="tag1" label="Tag 1"></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field dense :rules="rules.onlyNumbers" maxlength="30" v-model="tag2" label="Tag 2"></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field dense :rules="rules.onlyNumbers" maxlength="30" v-model="tag3" label="Tag 3"></v-text-field>
        </v-col>  
      </v-row> 

      <p class="title-user-scr">Mascotas</p>  
      <v-row>     
        <v-col cols="4">
          <v-text-field dense v-model="numPets" type="number" label="Número de mascotas"></v-text-field>
        </v-col> 
        <v-col cols="8">
          <v-text-field dense :rules="rules.lonmd" v-model="docuPets" label="Documentacion entregada"></v-text-field>
        </v-col>  
      </v-row>  

      <p class="title-user-scr">Situación financiera adeudo</p>  
      <v-row v-if="isAdmin">
        <v-col cols="4" v-for="(year) in lastFiveYears" :key="year">
          <v-text-field
            prefix="$"
            suffix="MXN"
            dense           
            type="number"
            v-model="debtValues[year]"
            :label="`Adeudo ${year}`"
          ></v-text-field>
        </v-col>
      </v-row>

      <p class="title-user-scr">Otros datos</p>  
      <v-row>   
        <v-col cols="12">  
          <v-text-field dense :rules="rules.lonxl" v-model="coments" label="Comentarios"></v-text-field>
        </v-col>
       <v-col cols="12">
        <v-textarea
          dense
          :rules="rules.lonxl"
          v-model="sanctions"
          label="Sanciones"
          rows="4"
          auto-grow
        ></v-textarea> 
       </v-col> 
      </v-row> 
    </div>

  </div>
</template>
 
<script>
export default {
  name: 'UserForm',
  props: {
    infoUser: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show1: false,
      show2: false,
      role: 'user',      
      usernameLogin:'',
      username: '',
      lotPurchased: '',
      email: '',     
      mobilePhone: '',
      password: '',
      confirmPassword: '',
      statusDebt: '',
      image: '',
      statusSocio: ['normal', 'moroso + 3 meses', 'en proceso de pago', 'perdida membresía'],     
      rules: {
          required: (value) => !!value || 'Required.',
          name: [
            (v) => !!v || 'Nombre is required',
            (v) => (v && v.length <= 60) || 'Nombre debe ser menor a 60 caracteres',
            (v) => (v && v.length >= 2) || 'Nombre debe ser mayor a 2 caracteres',
          ],
          min: (v) => (v && v.length >= 8) || 'Min 8 characters',
          emailMatch: () => 'The email and password you entered don\'t match',

          email: [
            (v) => !!v || 'E-mail is required',
            (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
          ],          
          emailContact: [ (v) => !v || /.+@.+\..+/.test(v) || 'E-mail must be valid' ],
          lonsm: [ (v) => !v || v.length <= 30 || 'Nombre debe ser menor a 30 caracteres' ],
          lonmd: [ (v) => !v || v.length <= 60 || 'Nombre debe ser menor a 60 caracteres' ],
          lonlg: [ (v) => !v || v.length <= 100 || 'Nombre debe ser menor a 100 caracteres' ],
          lonxl: [ (v) => !v || v.length <= 255 || 'Nombre debe ser menor a 255 caracteres' ],
          mobileReq: [
            (v) => !!v || 'Celular requerido',
            (v) => !v || /^[0-9\-()]*$/.test(v) || 'Celular Invalido. caráteres permitidos: [ 9-0, - ]',
          ],
          mobile: [ (v) => !v || /^[0-9\-()]*$/.test(v) || 'Celular Invalido. caráteres permitidos: [ 9-0, - ]' ],
          onlyNumbers: [ (v) => !v || /^[0-9]*$/.test(v) || 'Solo números 0-9 son permitidos' ],
        },
      statusPredio: ['escriturado', 'financiado', 'pagado', 'congelado' ],
      lotenum: '',
      manzana: '',
      street: '',
      legalStatus: '',
      placeOfResidence: '',
      contactName:'',
      contactEmail:'',
      contactMobile:'',
      hasWhats: false,
      tag1:'',
      tag2:'',
      tag3:'',
      numPets:'',
      docuPets:'',      
      coments: '',
      sanctions: '',
      currentYear: new Date().getFullYear(),
      lastFiveYears: null,
      debtValues: {},
    };
  },
  mounted() {
    this.lastFiveYears= this.getLastFiveYears();
    this.debtValues = this.infoUser.debts.reduce((acc, d) => {
      acc[d.year] = d.debt;
      return acc;
    }, {});
    if (this.infoUser.id) {
      this.role = this.infoUser.role;
      this.usernameLogin = this.infoUser.usernameLogin;
      this.username = this.infoUser.username;
      this.lotPurchased = this.infoUser.lotPurchased,     
      this.email = this.infoUser.email;           
      this.mobilePhone = this.infoUser.mobilePhone;
      this.password = this.infoUser.password || '';
      this.confirmPassword = this.infoUser.confirmPassword || '';      
      this.statusDebt = this.infoUser.statusDebt;
      this.lotenum = this.infoUser.lotenum;
      this.manzana = this.infoUser.manzana;
      this.street = this.infoUser.street;  
      this.legalStatus = this.infoUser.legalStatus;    
      this.placeOfResidence = this.infoUser.placeOfResidence;
      this.hasWhats = this.infoUser.hasWhats || false;
      this.contactName = this.infoUser.contactName;
      this.contactEmail = this.infoUser.contactEmail;
      this.contactMobile = this.infoUser.contactMobile;
      this.tag1 = this.infoUser.tag1;
      this.tag2 = this.infoUser.tag2;
      this.tag3 = this.infoUser.tag3;
      this.numPets = this.infoUser.numPets;
      this.docuPets = this.infoUser.docuPets;    
      this.coments = this.infoUser.coments;
      this.sanctions = this.infoUser.sanctions;
    }
  },
  watch: {
    infoUser(newValue) {
      this.lastFiveYears= this.getLastFiveYears();
      this.debtValues = this.infoUser.debts.reduce((acc, d) => {
        acc[d.year] = d.debt;
        return acc;
      }, {});
      if (newValue.id) {
        this.role = this.infoUser.role;
        this.usernameLogin = this.infoUser.usernameLogin;
        this.username = this.infoUser.username;
        this.lotPurchased = this.infoUser.lotPurchased;
        this.email = this.infoUser.email;      
        this.mobilePhone = this.infoUser.mobilePhone;
        this.password = this.infoUser.password || '';
        this.confirmPassword = this.infoUser.confirmPassword || '';       
        this.statusDebt = this.infoUser.statusDebt;
        this.lotenum = this.infoUser.lotenum;
        this.manzana = this.infoUser.manzana;
        this.street = this.infoUser.street;      
        this.legalStatus = this.infoUser.legalStatus;
        this.placeOfResidence = this.infoUser.placeOfResidence;
        this.hasWhats = this.infoUser.hasWhats;
        this.contactName = this.infoUser.contactName;
        this.contactEmail = this.infoUser.contactEmail;
        this.contactMobile = this.infoUser.contactMobile;
        this.tag1 = this.infoUser.tag1;
        this.tag2 = this.infoUser.tag2;
        this.tag3 = this.infoUser.tag3;
        this.numPets = this.infoUser.numPets;
        this.docuPets = this.infoUser.docuPets;              
        this.coments = this.infoUser.coments;
        this.sanctions = this.infoUser.sanctions;
      }
    },
  },
  computed: {
    modeEdit() {
      return this.infoUser.usernameLogin ? true : false;
    },
    isAdmin() {
      return this.$store.getters['session/user'].role === 'admin';
    },
  },
  methods: {
    selectFile(file) {
      this.image = file;
    },
    userFormData() {
      if (this.modeEdit) {
        const formData = new FormData();
        
        if (this.image) {
          formData.append('image', this.image, this.image.name);
        }
        if (this.password) {
          formData.append('confirmPassword', this.confirmPassword);
          formData.append('password', this.password);
        }        
        formData.append('username', this.username);
        formData.append('lotPurchased') || ''; 
        formData.append('email', this.email) || '';        
        formData.append('mobilePhone', this.mobilePhone) || '';       
        formData.append('statusDebt', this.statusDebt) || '';
        formData.append('lotenum', this.lotenum) || '';
        formData.append('manzana', this.manzana) || '';
        formData.append('street', this.street) || '';
        formData.append('legalStatus', this.legalStatus) || '';    
        formData.append('placeOfResidence', this.placeOfResidence) || '';
        formData.append('hasWhats', this.hasWhats) || false;
        formData.append('contactName', this.contactName) || '';
        formData.append('contactEmail', this.contactEmail) || '';
        formData.append('contactMobile', this.contactMobile) || '';
        formData.append('tag1', this.tag1) || '';
        formData.append('tag2', this.tag2) || '';
        formData.append('tag3', this.tag3) || '';
        formData.append('numPets', this.numPets) || 0;
        formData.append('docuPets', this.docuPets) || '';        
        formData.append('coments', this.coments) || '';
        formData.append('sanctions', this.sanctions) || '';
        formData.append('debts', this.debtValues);

        return {
          id: this.infoUser.id,
          user: formData,
        };
      }
      return null;
    },
    userData() {
      if (this.modeEdit) {
        const user = {
            username: this.username,     
            lotPurchased: this.lotPurchased || '',       
            mobilePhone: this.mobilePhone || '',          
            email: this.email || '',           
            statusDebt: this.statusDebt || '',
            lotenum: this.lotenum || '',
            manzana: this.manzana || '',
            street: this.street || '',
            legalStatus: this.legalStatus || '',
            placeOfResidence: this.placeOfResidence || '',
            hasWhats: this.hasWhats || false,
            contactName: this.contactName || '',
            contactEmail: this.contactEmail || '',
            contactMobile: this.contactMobile || '',
            tag1: this.tag1 || '',
            tag2: this.tag2 || '',
            tag3: this.tag3 || '',
            numPets: this.numPets || 0,
            docuPets: this.docuPets || '',            
            coments: this.coments || '',
            sanctions: this.sanctions || '',
            debts: this.debtValues,
          };
        if (this.password) {
        user.password = this.password;
        user.confirmPassword = this.confirmPassword;
        }
        return {
          id: this.infoUser.id,
          user,
        };
      }
      return {
        role: this.role,
        usernameLogin: this.usernameLogin,
        username: this.username,
        lotPurchased: this.lotPurchased,
        email: this.email,       
        mobilePhone: this.mobilePhone || '',
        password: this.password,
        confirmPassword: this.confirmPassword,       
        statusDebt: this.statusDebt,
        lotenum: this.lotenum || '',
        manzana: this.manzana || '',
        street: this.street || '',
        legalStatus: this.legalStatus || '', 
        placeOfResidence: this.placeOfResidence || '',
        hasWhats: this.hasWhats || false,
        contactName: this.contactName || '',
        contactEmail: this.contactEmail || '',
        contactMobile: this.contactMobile || '',
        tag1: this.tag1 || '',
        tag2: this.tag2 || '',
        tag3: this.tag3 || '',
        numPets: this.numPets || 0,
        docuPets: this.docuPets || '',        
        coments: this.coments || '',
        sanctions: this.sanctions || '',
        debts: this.debtValues,
      };
    },

    checkPassword () {
    if (this.password || this.confirmPassword) {
      if (this.password !== this.confirmPassword ) {
      return false;
      }
      return true;
    }
    },
    getLastFiveYears () {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;
      const startYear = currentMonth >= 11 ? currentYear + 1 : currentYear;
      return this.lastFiveYears = Array.from({ length: 5 }, (_, i) => startYear - (4 - i));
    }
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>